import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getOffers } from "../Application/Offers.bussines";
import { getOffersSelector } from "../Infrastructure/Offers.reducer";
import OffersBoard from "./OffersBoard";

export default function Offers() {
  const offers = useSelector(getOffersSelector);

  useEffect(() => {
    getOffers();
  }, []);

  return <OffersBoard data={offers} />;
}
